export type MarkupToolsState = {
  markupActiveTool: string;
  markupFillColor: string;
  markupFillStyle: string;
  markupFontColor: string;
  markupFontFamily: string;
  markupFontSize: number;
  markupFontStyle: string;
  markupFontWeight: string;
  markupLineColor: string;
  markupLineStyle: string;
  markupLineWidth: number;
  markupPointColor: string;
  markupPointOutlineColor: string;
  markupPointOutlineStyle: __esri.SimpleLineSymbolProperties["style"];
  markupPointOutlineWidth: number;
  markupPointSize: number;
  markupPointStyle: string;
  markupPolygonOutlineColor: string;
  markupPolygonOutlineStyle: string;
  markupPolygonOutlineWidth: number;
  markupText: string;
};

export type MarkupToolsActions = {
  setMarkupActiveTool: (tool: string) => void;
  setMarkupPointStyle: (style: string) => void;
  setMarkupLineStyle: (style: string) => void;
  setMarkupFillStyle: (style: string) => void;
  setMarkupPointSize: (size: number) => void;
  setMarkupPointColor: (color: string) => void;
  setMarkupLineColor: (color: string) => void;
  setMarkupLineWidth: (width: number) => void;
  setMarkupPointOutlineStyle: (style: string) => void;
  setMarkupPointOutlineWidth: (width: number) => void;
  setMarkupPointOutlineColor: (color: string) => void;
  setMarkupPolygonOutlineStyle: (style: string) => void;
  setMarkupPolygonOutlineWidth: (width: number) => void;
  setMarkupPolygonOutlineColor: (color: string) => void;
  setMarkupFillColor: (color: string) => void;
  setMarkupText: (text: string) => void;
  setMarkupFontStyle: (style: string) => void;
  setMarkupFontSize: (size: number) => void;
  setMarkupFontFamily: (family: string) => void;
  setMarkupFontColor: (color: string) => void;
  setMarkupFontWeight: (weight: string) => void;
};

export const createMarkupToolsSlice = (
  set,
  get
): MarkupToolsState & MarkupToolsActions => ({
  markupActiveTool: "",
  setMarkupActiveTool: (tool) => set({ markupActiveTool: tool }),
  markupPointStyle: "circle",
  setMarkupPointStyle: (style) => set({ markupPointStyle: style }),
  markupLineStyle: "solid",
  setMarkupLineStyle: (style) => set({ markupLineStyle: style }),
  markupFillStyle: "solid",
  setMarkupFillStyle: (style) => set({ markupFillStyle: style }),
  markupPointSize: 10,
  setMarkupPointSize: (size) => set({ markupPointSize: size }),
  markupPointColor: "#FFFF00",
  setMarkupPointColor: (color) => set({ markupPointColor: color }),
  markupLineColor: "#FF0000",
  setMarkupLineColor: (color) => set({ markupLineColor: color }),
  markupLineWidth: 1,
  setMarkupLineWidth: (width) => set({ markupLineWidth: width }),
  markupPointOutlineStyle: "solid",
  setMarkupPointOutlineStyle: (style) =>
    set({ markupPointOutlineStyle: style }),
  markupPointOutlineWidth: 1,
  setMarkupPointOutlineWidth: (width) =>
    set({ markupPointOutlineWidth: width }),
  markupPointOutlineColor: "#000000",
  setMarkupPointOutlineColor: (color) =>
    set({ markupPointOutlineColor: color }),
  markupPolygonOutlineStyle: "solid",
  setMarkupPolygonOutlineStyle: (style) =>
    set({ markupPolygonOutlineStyle: style }),
  markupPolygonOutlineWidth: 1,
  setMarkupPolygonOutlineWidth: (width) =>
    set({ markupPolygonOutlineWidth: width }),
  markupPolygonOutlineColor: "#000000",
  setMarkupPolygonOutlineColor: (color) =>
    set({ markupPolygonOutlineColor: color }),
  markupFillColor: "#FF0000",
  setMarkupFillColor: (color) => set({ markupFillColor: color }),
  markupText: "",
  setMarkupText: (text) => set({ markupText: text }),
  markupFontStyle: "normal",
  setMarkupFontStyle: (style) => set({ markupFontStyle: style }),
  markupFontSize: 12,
  setMarkupFontSize: (size) => set({ markupFontSize: size }),
  markupFontFamily: "Georgia",
  setMarkupFontFamily: (family) => set({ markupFontFamily: family }),
  markupFontColor: "#000000",
  setMarkupFontColor: (color) => set({ markupFontColor: color }),
  markupFontWeight: "normal",
  setMarkupFontWeight: (weight) => set({ markupFontWeight: weight }),
});
